// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enable_pwa: true,
  app: {
    url: 'https://app.demo.comvergence.net/',
  },
  api: {
    root: 'https://api.demo.comvergence.net/api',
  },
  fileserver: {
    downloads: 'https://api.demo.comvergence.net/api/downloads',
    images: 'https://api.demo.comvergence.net/api/images',
    radar: 'https://api.demo.comvergence.net/api/comv/radar',
    media: 'https://media.comvergence.net/',
  },
  auth: {
    providers: {
      google: { enabled: false }, // sign-in and register
      facebook: { enabled: false }, // sign-in and register
      email: {
        enabled: true,
        register: false,
        forgot: false,
        fields: {
          displayName: true,
          lastname: true,
          firstname: true,
          phone: true,
        },
      },
      phone: { enabled: false },
    },
    roles: {
      whitelist: ['super-admin', 'comverger'],
      blacklist: [],
    },
  },
  pusher: {
    key: '5df27940140b125f7c20',
    cluster: 'eu',
  },
  linkedin: {
    search_url: 'https://www.linkedin.com/search/results/companies/?keywords=',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
